export default __webpack_public_path__ + "static/media/juego4_ganar.70e00fa5.png";